import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "gfu-project-test-mode-bar",
  "data-qa": "project-test-mode-info"
}
const _hoisted_2 = { class: "_tc--white" }
const _hoisted_3 = { class: "_mt-0" }
const _hoisted_4 = { "data-qa": "testing-bar:CurrentTestingPhaseName" }
const _hoisted_5 = { "data-qa": "testing-bar:TestingUserGroupsNames" }
const _hoisted_6 = { "data-qa": "testing-bar:UnpublishedContentVisibleLabel" }
const _hoisted_7 = { class: "_mt-2" }
const _hoisted_8 = {
  key: 0,
  class: "_ml-1"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_button = _resolveComponent("base-button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, [
        _cache[4] || (_cache[4] = _createTextVNode(" Testing: ", -1 /* CACHED */)),
        _createElementVNode("strong", _hoisted_4, _toDisplayString($options.currentTestingPhaseName), 1 /* TEXT */),
        _cache[5] || (_cache[5] = _createTextVNode(". ", -1 /* CACHED */)),
        ($props.testingUserGroups.length)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _cache[2] || (_cache[2] = _createTextVNode(" User group: ", -1 /* CACHED */)),
              _createElementVNode("strong", _hoisted_5, _toDisplayString($options.testingUserGroupsNames), 1 /* TEXT */),
              _cache[3] || (_cache[3] = _createTextVNode(". ", -1 /* CACHED */))
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true),
        _cache[6] || (_cache[6] = _createTextVNode(" Unpublished content: ", -1 /* CACHED */)),
        _createElementVNode("strong", _hoisted_6, _toDisplayString($options.unpublishedContentVisibleLabel), 1 /* TEXT */),
        _cache[7] || (_cache[7] = _createTextVNode(". ", -1 /* CACHED */))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          class: "_tdu _pa-0 _mr-2",
          onClick: _cache[0] || (_cache[0] = (...args) => ($options.onOpenModal && $options.onOpenModal(...args))),
          "data-qa": "testing-bar:LearnMore"
        }, "learn more"),
        _createElementVNode("button", {
          class: "_tdu _pa-0",
          onClick: _cache[1] || (_cache[1] = (...args) => ($options.onCloseTesterMode && $options.onCloseTesterMode(...args))),
          "data-qa": "testing-bar:QuitTesterMode"
        }, "quit tester mode")
      ])
    ]),
    _createVNode(_component_base_button, {
      theme: "searchPrimary",
      width: "compact",
      weight: "thin",
      shadow: "tight",
      class: "_ttr _as-fs _ml-2",
      shape: $options.buttonShape,
      onClick: $options.onFiltersClick,
      "data-qa": "testing-bar:AdjustPreview"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_base_icon, {
          class: "_tc--accent",
          name: "sliders-h"
        }),
        (!$options.isMobile)
          ? (_openBlock(), _createElementBlock("strong", _hoisted_8, "adjust preview"))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["shape", "onClick"])
  ]))
}